import React from 'react';
import propTypes from 'prop-types';
import { FaDownload } from 'react-icons/fa';

export default function AttachmentList({ items }) {
  if (!items.length) return <></>;

  return (
    <>
      <h6>{`Anexo${items.length > 1 ? 's' : ''}`}</h6>
      <ul className="list-group">
        {items.map(item => (
          <li className="list-group-item d-flex justify-content-between" key={item._id}>
            <span>{item.name}</span>
            <a href={item.path} target="_blank" rel="noopener noreferrer" download>
              <FaDownload />
            </a>
          </li>
        ))}
      </ul>
    </>
  );
}

AttachmentList.propTypes = {
  items: propTypes.array,
};

AttachmentList.defaultProps = {
  items: [],
};
